import LayoutInside from '@/layout/LayoutInside';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ArrowLeft } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import AffiliateReferralsTab from './Tabs/AffiliateReferralsTab';
import PlatformReferralsTab from './Tabs/PlatformReferralsTab';

export default function PartnerCommissions() {
  const { t } = useTranslation(['reports', 'affiliates', 'referAndEarn', 'common']);
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'products';

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  return (
    <LayoutInside 
      items={[
        { text: t('common:reports', 'Relatórios'), link: '/reports' },
        { text: t('reports:referrals', 'Indicações'), link: '/reports/partner-commissions' }
      ]}
    >
      <div className="grid gap-6">
        <Link to="/reports" className="w-fit">
          <Button
            variant="default"
            className="bg-transparent text-colorText hover:bg-transparent p-0"
          >
            <ArrowLeft size={16} />
            {t('common:back')}
          </Button>
        </Link>

        <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="grid w-full grid-cols-2 max-w-md mb-6 bg-zinc-900 border border-zinc-800">
          <TabsTrigger value="products" className="data-[state=active]:bg-zinc-800 data-[state=active]:text-white text-zinc-400">
            {t('reports:referral_products', 'Indicação de Afiliados')}
          </TabsTrigger>
          <TabsTrigger value="platform" className="data-[state=active]:bg-zinc-800 data-[state=active]:text-white text-zinc-400">
            {t('reports:referral_platform', 'Indicação de Produtores')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="products" className="focus-visible:outline-none">
          <AffiliateReferralsTab />
        </TabsContent>
        <TabsContent value="platform" className="focus-visible:outline-none">
          <PlatformReferralsTab />
        </TabsContent>
      </Tabs>
      </div>
    </LayoutInside>
  );
}
